import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import { buildURL } from 'react-imgix';
import { IMAGE_DEFAULT_QUALITY } from './constants';
export var getPreviewUrl = function getPreviewUrl(_ref) {
  var _ref$previewWidth = _ref.previewWidth,
      previewWidth = _ref$previewWidth === void 0 ? 100 : _ref$previewWidth,
      _ref$previewQuality = _ref.previewQuality,
      previewQuality = _ref$previewQuality === void 0 ? 30 : _ref$previewQuality,
      _ref$previewImgixPara = _ref.previewImgixParams,
      previewImgixParams = _ref$previewImgixPara === void 0 ? {} : _ref$previewImgixPara,
      src = _ref.src;
  return buildURL(src, _objectSpread({
    auto: 'format',
    w: previewWidth,
    q: previewQuality
  }, previewImgixParams));
};
export var applyForDpr = function applyForDpr(values, dpr) {
  if (typeof values === 'number') {
    return values;
  }

  if (dpr === 5) {
    var _ref2, _ref3, _ref4, _values$;

    return (_ref2 = (_ref3 = (_ref4 = (_values$ = values[5]) != null ? _values$ : values[4]) != null ? _ref4 : values[3]) != null ? _ref3 : values[2]) != null ? _ref2 : values[1];
  }

  if (dpr === 4) {
    var _ref5, _ref6, _values$2;

    return (_ref5 = (_ref6 = (_values$2 = values[4]) != null ? _values$2 : values[3]) != null ? _ref6 : values[2]) != null ? _ref5 : values[1];
  }

  if (dpr === 3) {
    var _ref7, _values$3;

    return (_ref7 = (_values$3 = values[3]) != null ? _values$3 : values[2]) != null ? _ref7 : values[1];
  }

  if (dpr === 2) {
    var _values$4;

    return (_values$4 = values[2]) != null ? _values$4 : values[1];
  }

  return values[1];
};
export var getQuality = function getQuality(quality, defaultQuality, dpr) {
  var _ref8;

  return (_ref8 = quality != null ? quality : defaultQuality) != null ? _ref8 : IMAGE_DEFAULT_QUALITY[dpr];
};